// extracted by mini-css-extract-plugin
module.exports = {"root":"InfralistSumFilter_root__nhAE5","sum":"InfralistSumFilter_sum__2-P6K"};